import { useRef, useEffect } from 'react'

/**
 * 選んだファイル（File）の表示用 URL を、ファイルごとに1つだけ作って使い回す
 *
 * 描画のたびに URL.createObjectURL で作り直すと、<embed> の PDF が読み込み直されてちらつく
 * （入力のたびに画面が描き直されるため）。表示しなくなったファイルの URL は解放する。
 *
 * @param {Array} files 画面に出しているファイル（保存済みの文字列 URL が混ざっていてもよい）
 * @returns {(file: File) => string} 表示用 URL を返す関数
 */
export default function useObjectUrls (files) {
  const urls = useRef(new Map())

  // 描画のたびに、もう出していないファイルの URL を解放する
  // （ファイルの一覧は配列をその場で書き換えることがあるため、依存配列ではなく毎回確認する）
  useEffect(() => {
    const inUse = new Set(files)
    urls.current.forEach((url, file) => {
      if (!inUse.has(file)) {
        URL.revokeObjectURL(url)
        urls.current.delete(file)
      }
    })
  })

  useEffect(() => () => {
    urls.current.forEach(url => URL.revokeObjectURL(url))
    urls.current.clear()
  }, [])

  return (file) => {
    if (!urls.current.has(file)) {
      urls.current.set(file, URL.createObjectURL(file))
    }
    return urls.current.get(file)
  }
}
